// Reads the setup preview by draft reminder id. The server numbers reminders
// within the ones the preview sent, so `reminderIds[index]` is the draft reminder
// behind `occurrence.reminders[].index`. Closed occurrences never send anything.

const openOccurrences = preview => (preview?.occurrences ?? []).filter(occurrence => !occurrence.closed)

const entriesFor = (preview, reminderIds, reminderId) => {
  const index = (reminderIds ?? []).indexOf(reminderId)
  if (index < 0) return []
  return openOccurrences(preview)
    .map(occurrence => (occurrence.reminders ?? []).find(reminder => reminder.index === index))
    .filter(Boolean)
}

export const reminderSendsAt = (preview, reminderIds, reminderId) =>
  entriesFor(preview, reminderIds, reminderId).find(reminder => reminder.sends_at)?.sends_at ?? null

export const reminderSkipReason = (preview, reminderIds, reminderId) => {
  const entries = entriesFor(preview, reminderIds, reminderId)
  if (entries.some(reminder => reminder.sends_at)) return null
  return entries.find(reminder => reminder.skipped)?.skipped ?? null
}

export const reminderForIndex = (reminders, reminderIds, index) => {
  const id = (reminderIds ?? [])[index]
  return id === undefined ? null : reminders.find(reminder => reminder.id === id) ?? null
}
